interface IQtySelectorParams {
  qty: number;
  step: number;
  min: number;
  max: number;
  notificationCallback: (notification: any) => void;
  i18n: any;
}
export function validateQtySelector({
  qty, step, min, max, notificationCallback, i18n,
}: IQtySelectorParams): boolean {
  if (qty < min) {
    notificationCallback({
      id: Symbol('product-update-qty-success'),
      message: `${i18n.t('The least you can purchase is x.', { x: min })}`,
      type: 'warning',
      icon: 'check',
      persist: false,
      title: 'Cart',
    });
    return false;
  }
  if (qty > max) {
    notificationCallback({
      id: Symbol('product-update-qty-success'),
      message: `${i18n.t('The most you can purchase is x.', { x: max })}`,
      type: 'warning',
      icon: 'check',
      persist: false,
      title: 'Cart',
    });
    return false;
  }
  if (qty % step !== 0) {
    notificationCallback({
      id: Symbol('product-update-qty-success'),
      message: `${i18n.t('You can only buy this product in quantities of x at a time.', { x: step })}`,
      type: 'warning',
      icon: 'check',
      persist: false,
      title: 'Cart',
    });
    return false;
  }

  return true;
}
